export default __webpack_public_path__ + "79ecf233385d6aeba77013d0be09ed1c.svg";